export interface IGift {
    gift_id: string,
    name: string,
    thumb_url: string,
    image_url: string,
    front_value: number,
    cost_price_range: number[],
    taobao_keyword: string,
    pdd_keyword: string,
}

export class Gifts {
    constructor(public readonly data: { [key: string]: IGift }) {
        //
    }

    emptyGift(): IGift {
        return {
            gift_id: '',
            name: '',
            thumb_url: '',
            image_url: '',
            front_value: 0,
            cost_price_range: [],
            taobao_keyword: '',
            pdd_keyword: '',
        }
    }

    randomGift(): IGift {
        return this.data[Object.keys(this.data)[Math.floor(Math.random() * Object.keys(this.data).length)]]
    }
}
